import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import fetch from '../../fetch.js';
import { customHeaders, thriweMarketPlaceUrl, alrajhiValetURL } from '../../../../Containers/Config/index.js';
import {
  VENDOR_BOOKINGS_DATA_ALRAJHI_REJECT,
  VENDOR_BOOKINGS_DATA_SUCCESS_ALRAJHI_REJECT,
  VENDOR_BOOKINGS_DATA_ERROR_ALRAJHI_REJECT,
} from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* GetVendorBookingsAlrajhiReject({ payload }) {
  let projectBaseURL = payload?.headers?.code === 'SCB_V1' ? thriweMarketPlaceUrl : alrajhiValetURL;

  try {
    const bookingId = payload?.urlParam?.bookingId;
    const response = yield call(apiCall, {
      url: `${projectBaseURL}/v3/vendor/reject-booking/${bookingId}`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': payload?.headers?.code,
      },
      params: {},
      data: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({ type: VENDOR_BOOKINGS_DATA_SUCCESS_ALRAJHI_REJECT, payload: response?.data });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: VENDOR_BOOKINGS_DATA_ERROR_ALRAJHI_REJECT, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: VENDOR_BOOKINGS_DATA_ERROR_ALRAJHI_REJECT, payload: error });
  }
}

export function* watchGetVendorBookingsAlrajhiReject() {
  yield takeEvery(VENDOR_BOOKINGS_DATA_ALRAJHI_REJECT, GetVendorBookingsAlrajhiReject);
}

function* vendorBookingsSagaAlrajhiReject() {
  yield all([fork(watchGetVendorBookingsAlrajhiReject)]);
}

export default vendorBookingsSagaAlrajhiReject;
